import { useTranslation } from 'react-i18next';
import React from 'react';
import { Typography } from '@mui/material';

const UserCount = ({ count }: { count: number }): JSX.Element => {
    const { t } = useTranslation();
    const message = t('adminSpace.usersList.userCount', { count });
    return (
        <Typography variant="body2" color="mediumGrey">
            {message}
        </Typography>
    );
};

export default UserCount;
